
import './style/common.css';

import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './router/index'
import store from './store'
import './config/rem'
import App from './App'
import Qs from 'qs'
import {GetQueryString,getWxAuth} from './utils/author'
import {setStore, getStore, removeStore} from './config/mUtils'
import {pushOrder} from './utils/wechat'
import VueLazyload from 'vue-lazyload'  //引入这个懒加载插件
Vue.use(VueLazyload);


//挂载swiper
import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper);

//import 'babel-polyfill'
import Es6Promise from 'es6-promise'
require('es6-promise').polyfill();
Es6Promise.polyfill();

//提示弹窗
import {Alert, Confirm, Toast, Loading} from './wc-messagebox'

Vue.use(Alert);
Vue.use(Confirm);
Vue.use(Toast);
Vue.use(Loading)

Vue.use(require('vue-wechat-title'));

Vue.use(VueRouter);

import global from './utils/glabal_song'
Vue.prototype.global = global;


const router = new VueRouter({
  routes,
  mode: 'hash',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      if (from.meta.keepAlive) {
        from.meta.savedPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      }
      return { x: 0, y: to.meta.savedPosition || 0 }
    }
  }
})


router.beforeEach((to, from, next) => {
  //let userInfo = {
  //  //openid: "oUzJo5Hhau_Waog3gjN2TQ76vobc", //张彪
  //  openid: "oUYE8xN4ZRA-u53-uR_qP7GeLJu8", //黄月
  //  //openid: "oUYE8xFTWojPxEww36urMQrLgPBQ", //黄月
  //  //openid: "oUYE8xOkfCRRKQwYbA1HUiyUnaQE", //何放
  //  //openid: "123456", //测试
  //  //openid: "oUzJo5B4ovVaETqvrbTo6fcenEFQ",
  //  txOpenid: "oUYE8xN4ZRA-u53-uR_qP7GeLJu8",
  //  //headimg: "https://filewc.geeker.com.cn/jpjs/upload/headimg/20200926/aby8dj3j36da68jwjh4gj8fgmhef5cf76j13j1.jpg",
  //  headimg: "https://filewc.geeker.com.cn/jpjs/upload/headimg/20230608/31pw3gc1asjp1629nz5h3a955hx9a4by1i732s.jpg",
  //  utype: "user",
  //  city: "成都",
  //  jointime: "2018-11-06 12:51:13",
  //  gender: 1,
  //  istui: 0,
  //  unionId: "oINhv0zA9xZ0xGvSvmEX6I6Lx5Gw",
  //  uptime: "2018-11-06 14:32:57",
  //  //name: "缺心眼子",
  //  name: "张阁",
  //  id: 53891,
  //  state: 1
  //};
  //setStore("userInfo", userInfo)
  //if (to.meta.title) { document.title = to.meta.title; }
  //console.log(to)
  //if(to.path == '/video-vr'&&to.query&&to.query.id=='4771'&&to.query.spotid) {
  //  next({
  //    path: '/video-play-pt',
  //    query: {
  //      spotid: to.query.spotid
  //    }
  //  })
  //} else {
  //  next();
  //}
  //return false;

  const query = Qs.parse(location.hash.substring(3));
  let openidMini = getStore("openidMini");
  let openid = query.openid || GetQueryString("openid") || (openidMini && openidMini.openid) || "";
  if(openid){//小程序端的openid
    setStore("openidMini",{openid: openid});
  }

  let snsInfo = getStore("snsInfo");
  let sns_info = query.sns_info || GetQueryString("sns_info") || (snsInfo && snsInfo.sns_info) || ""; //sns_info :   xc_base (app主动授权)  fz_auth(其他第三方授权)  其他值维持原样
  if(sns_info){
    setStore("snsInfo",{sns_info: sns_info});
  }

  let payInfo = getStore("payInfo");
  let pay_info = query.pay_info || GetQueryString("pay_info") || (payInfo && payInfo.pay_info) || "";
  if(pay_info){//pay_info :  1 (h支付) 其他值维持原样
    setStore("payInfo",{pay_info: pay_info});
  }

  console.log('to.path：'+to.path);
  var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  if (isMobile) { //在PC端
    isMobile = true;
  }else {
    isMobile = false;
  }
  console.log(isMobile);
  if(to.path == '/authorize' || to.path == '/authorize-efz' || to.path == '/clear' || (to.path == '/map-vr' && !isMobile)){
    next();
    return false;
  }else {
    try {
      let userInfo =  getStore("userInfo");
      let userInfo1 =  getStore("userInfo1",1);

      if((userInfo1 && userInfo1.openid) || (userInfo && userInfo.openid)){
        let timeNow = new Date().getTime();
        let timelogin = parseInt((getStore("timelogin",1)&&getStore("timelogin",1).timelogin) || 0);

        if(timelogin==0 || (timelogin>0 && (timeNow-timelogin)>1000*3600*24*30) || (userInfo1&&userInfo1.openid&&userInfo1.openid.indexOf('oEU-')===0 || userInfo&&userInfo.openid&&userInfo.openid.indexOf('oEU-')===0)){//保存登录状态10天
          removeStore("userInfo");
          removeStore("userInfo1",1);
          removeStore("timelogin",1);
          toNext();
        }else {
          if(userInfo1 && userInfo1.openid){
            setStore("userInfo", userInfo1);
          }else {
            setStore("userInfo1", userInfo,1);
          }
          if (to.meta.title) { document.title = to.meta.title; }
          if(to.path == '/video-vr'&&to.query&&to.query.id=='4771'&&to.query.spotid) {
            next({
              path: '/video-play-pt',
              query: {
                spotid: to.query.spotid
              }
            })
          } else {
            next();
          }
        }
      }else {
        toNext();
      }
    } catch (e) {
      toNext();
    }
  }

  function toNext(){

    let hash = window.sessionStorage.getItem("hash") || '';
    if(hash == "" || hash == null || hash == 'undefined'){
      hash = window.location.href.split('#')[1];
      window.sessionStorage.setItem("hash", hash);
    }
    console.log('main.js：'+hash)
    if(to.path == '/400'||to.path == '/401'){
      next();
    }else {
      if(sns_info=='xc_base' || sns_info=='fz_auth' || sns_info=='ykb_auth'){
        next({
          path: '/authorize?sns_info='+sns_info
        });
        return false;
      }else {
        getWxAuth(function (data) {
          if (data.status == 200 && data.data.errcode === '00000') {
            setStore("timelogin",{timelogin: new Date().getTime()},1);
            setStore("userInfo", data.data.data);
            setStore("userInfo1", data.data.data,1);
            if (to.meta.title) { document.title = to.meta.title; }
            //window.location = location.href.split('#')[0].split('?')[0]+'#'+hash;
            window.location.replace(window.location.href.split('#')[0].split('?')[0]+'#'+hash);
            window.sessionStorage.setItem("hash", "");
            if(to.path == '/video-vr'&&to.query&&to.query.id=='4771'&&to.query.spotid) {
              next({
                path: '/video-play-pt',
                query: {
                  spotid: to.query.spotid
                }
              })
            } else {
              next();
            }
            return false;
          }else {
            next({
              path: '/400'
            })
          }
        })
      }
    }
  }


});

new Vue({
  store,
  router,
  el: '#root',
  components: {
    App
  },
  template: '<App/>'
})
// const root = document.getElementById('root');
// console.log(root);





// WEBPACK FOOTER //
// ./src/main.js